/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- ADD-ON TYPES COMMUNITY TOP ARTICLES PLACEHOLDER IMAGES: STYLES --------------- ++++++++++ */
export default theme => ({
    placeholderimages: {
        '& .sectioncontent': {
            display: 'flex',
            flexFlow: 'row wrap',
            width: '100%',
            '& .control': {
                minWidth: pxToEm(172),
                marginBottom: pxToEm(8),
                marginRight: pxToEm(8),
                boxShadow: 'none',
                '&.selected-true': {
                    background: 'rgba(129, 201, 255, 0.09)'
                }
            },
            '& .imageuploader': {
                marginLeft: pxToEm(24),
                '& .inputbutton': {
                  '&:hover': {
                    filter: 'brightness(93%)',
                    transition: 'all .2s linear 0s'
                  }
                },
                '& button': {
                    fontWeight: 500,
                    background: 'rgb(241 244 248)',
                },
                '& .imagepreview': {
                    fontWeight: 'normal'
                }
            }
        }
    }
});
